import React from 'react';
import './button.css';

export const Button = React.forwardRef(({ children, variant = 'primary', onClick, disabled, className = '', icon, iconRight, size, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={`button ${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && icon}
      {children}
      {iconRight && iconRight}
    </button>
  );
});

Button.displayName = 'Button'; 